/**
 * @file 照片查看次数打点
 * @author Kody
 * @date 2019-08-12
 */
import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IOutput {
    result: boolean;
}

export const setPhotoCount = (elementId: number): Promise<IOutput> => {
    return fetchData(Api.PHOTO_SET_COUNT, { element_id: elementId }).then((res: IResponse<IOutput>) => {
        return res.data as IOutput;
    });
};
